import { getUser } from './user';

export const isAccountFetching = state => !getUser(state).fetched;
export const userHasAccount = state => !!getUser(state).account;
export const userRequiresAccountSetup = state => !isAccountFetching(state) && !userHasAccount(state);



// WEBPACK FOOTER //
// ./src/selectors/account.js